import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Label,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import { MDBDataTable } from "mdbreact";
import { Link, useLocation, useParams } from "react-router-dom";

const ChildSangathanMemberList = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [sangathansMemberList, setSangathansMemberList] = useState([]);
  const [totalUserCount, setSangathanCount] = useState(0);
  const [sangathanUserCount, setSangathanUserCount] = useState(0);
  const { childId } = useParams();
  const location = useLocation();
  const hierarchy = (location.state?.hierarchy || []).filter(
    (item) => typeof item === "object",
  );

  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Sangathan Member List", link: "#" },
  ];

  useEffect(() => {
    onGetParentSangathanList(childId);
    props.setBreadcrumbItems("Sangathan Member List", breadcrumbItems);
  }, [childId]);

  function onGetParentSangathanList() {
    setLoading(true);

    const urlPath = `/sangathan/sangathanlist/${childId}`;

    fetch(url.beta_url + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          setSangathansMemberList(responseData.result.sangathanList);
          setSangathanCount(responseData.result.sangathanCountData);
          setSangathanUserCount(responseData.result.sangathanCount);
        } else {
          console.error("API Error:", responseData.error || "Unknown error");
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  const formattedList = sangathansMemberList.map((data) => ({
    ...data,
    totalCount: data.totalUsers,
    sangathanCount: data.totalUserCount,
    sangathanName: [
      <Link
        to={`/parent-sangathans-list/${data.parentId}/child-sangathans-list/${data._id}`}
        state={{
          hierarchy: [
            ...(location.state?.hierarchy || []),
            { id: data._id, name: data.name },
          ],
        }}
      >
        {data.name}({data.subLevelCount})
      </Link>,
    ],
    Action: [
      <>
        <Link
          to={`/sangathan/view-member-list/${data._id}/sangathan`}
          className="btn btn-outline-primary me-2"
        >
          Sangathan User <i className="fa fa-eye"></i>
        </Link>
        <Link
          to={`/sangathan/view-member-list/${data._id}/subsangathan`}
          className="btn btn-outline-secondary"
        >
          Sub Sangathan All Users <i className="fa fa-eye"></i>
        </Link>
      </>,
    ],
  }));
  const totalUsersSum = formattedList.reduce(
    (acc, curr) => acc + Number(curr.totalCount || 0),
    0,
  );
  const sangathanUsersSum = formattedList.reduce(
    (acc, curr) => acc + Number(curr.sangathanCount || 0),
    0,
  );
  const footerRow = {
    sangathanName: <strong>Total</strong>,
    totalCount: <strong>{totalUsersSum}</strong>,
    sangathanCount: <strong>{sangathanUsersSum}</strong>,
    Action: "", // Empty for the action column
  };
  const tableData = {
    columns: [
      {
        label: "Sangathan Name",
        field: "sangathanName",
        width: 23,
        footer: "Total",
      },
      {
        label: "Sangathan Users",
        field: "sangathanCount",
        width: 13,
        footer: sangathanUsersSum,
      },
      {
        label: (
          <div>
            Total Users
            <br />
            (Sub + Sangathan)
          </div>
        ),
        field: "totalCount",
        width: 13,
        footer: totalUsersSum,
      },
      { label: "Action", field: "Action", width: 13, footer: "" },
    ],
    rows: [...formattedList, footerRow],
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="12">
                    <CardTitle className="h4 mb-0">Sangathan List</CardTitle>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/sangathan-member-list">Home</Link>
                        </li>
                        {hierarchy.map((item, i) => {
                          const isLast = i === hierarchy.length - 1;
                          return (
                            <li
                              key={item.id}
                              className={`breadcrumb-item ${isLast ? "active" : ""}`}
                              aria-current={isLast ? "page" : undefined}
                            >
                              {isLast ? (
                                item.name
                              ) : (
                                <Link
                                  to={`/parent-sangathans-list/${item.id}`}
                                  state={{
                                    hierarchy: hierarchy.slice(0, i + 1),
                                  }}
                                >
                                  {item.name}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                      </ol>
                    </nav>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div class="row">
                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    entries={20}
                    data={tableData}
                    noBottomColumns={true}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(ChildSangathanMemberList);
